import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    ATTENDANCE_GEOFENCE_REPORT: "api/GetUserGeoFence",
    ATTENDENANCE_USER_EXPORT : "api/GetUserGeoFence/Export",    
}

export const getAttendanceGeoFenceReport = async (payload: any): Promise<ApiResponse<any[]>> => {
    const response = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.ATTENDANCE_GEOFENCE_REPORT, { params: payload });
    return response.data;
};
    
export const getAttendanceLogsReport = async (payload: any): Promise<any> => {   
    const response = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.ATTENDENANCE_USER_EXPORT, { params: payload, responseType: "arraybuffer" });
    return response;
};

const AttendanceLogsService = {
    getAttendanceGeoFenceReport,
    getAttendanceLogsReport,
}

export default AttendanceLogsService;